import { type RouteObject } from 'react-router-dom';
import { lazyWithRetry } from '@repo/error';

import DraftExistsGuard from '@features/ownedParkingCreate/guards/DraftExistsGuard';
import ParkingCreateConsentGuard from '@features/ownedParkingCreate/guards/ParkingCreateConsentGuard';
import { AuthGuard } from '@features/auth';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

const ParkingOwnershipSelectionPage = lazyWithRetry(
  () => import('@features/ownedParkingCreate/pages/ParkingOwnershipSelectionPage')
);
const OwnParkingPage = lazyWithRetry(() => import('@features/ownedParkingCreate/pages/OwnParkingPage'));
const SpotsCreatorPage = lazyWithRetry(() => import('@features/ownedParkingCreate/pages/SpotsCreatorPage'));
const EntranceLocationPage = lazyWithRetry(() => import('@features/ownedParkingCreate/pages/EntranceLocationPage'));
const LotModePage = lazyWithRetry(() => import('@features/ownedParkingCreate/pages/LotModePage'));

export const ownedParkingCreateRoutes: RouteObject[] = [
  {
    element: <ParkingCreateConsentGuard />,
    children: [
      {
        element: <AuthGuard />,
        children: [
          {
            path: ROUTE_PATHS[RouteName.MY_PARKING_CREATE],
            element: <ParkingOwnershipSelectionPage />,
          },
          {
            path: ROUTE_PATHS[RouteName.MY_PARKING_CREATE_OWN],
            element: <OwnParkingPage />,
          },
          {
            element: <DraftExistsGuard />,
            children: [
              {
                path: ROUTE_PATHS[RouteName.MY_PARKING_CREATE_ENTRANCE_LOCATION],
                element: <EntranceLocationPage />,
              },
              {
                path: ROUTE_PATHS[RouteName.MY_PARKING_CREATE_LOT_MODE],
                element: <LotModePage />,
              },
              {
                path: ROUTE_PATHS[RouteName.MY_PARKING_CREATE_SPOTS],
                element: <SpotsCreatorPage />,
              },
            ],
          },
        ],
      },
    ],
  },
];
